import { http } from "api/http"

export type FilterOption = {
  value: string
  label: string
}

type FilterResponse = {
  data: {
    id: string
    label: string
  }[]
}

const makeOptions = (res: FilterResponse): FilterOption[] =>
  res.data?.map((x) => ({
    value: x.id,
    label: x.label,
  })) ?? []

export const getMarketsOptions = async (_key: string) => {
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/markets")
    .json()
  return makeOptions(res)
}

export const getCompaniesOptions = async (_key: string, marketId: string) => {
  const searchParams = new URLSearchParams({ marketId })
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/companies", { searchParams })
    .json()
  return makeOptions(res)
}
export const getClientsOptions = async (_key: string, marketId: string) => {
  const searchParams = new URLSearchParams({ marketId })
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/clients", { searchParams })
    .json()
  return makeOptions(res)
}
export const getSuppliersOptions = async (_key: string, marketId: string) => {
  const searchParams = new URLSearchParams({ marketId })
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/suppliers", { searchParams })
    .json()
  return makeOptions(res)
}
export const getChannelsOptions = async (_key: string, marketId: string) => {
  const searchParams = new URLSearchParams({ marketId })
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/channels", { searchParams })
    .json()
  return makeOptions(res)
}

export const getMediaTypesOptions = async (_key: string, marketId: string) => {
  const searchParams = new URLSearchParams({ marketId })
  const res: FilterResponse = await http
    .get("reporting/buying-billing/filters/media-type-semantics", {
      searchParams,
    })
    .json()
  return makeOptions(res)
}
